export default "__VITE_ASSET__7c78ca15__"